export const initMasthead = () => {
	const MastheadObject = {
		container: document.getElementById('masthead__container') as HTMLDivElement,
		menu: document.getElementById('masthead__menu') as HTMLUListElement,
		toggle: document.getElementById('masthead__navigation-toggle') as HTMLButtonElement,

		_init(): void {
			this._bindClass();
			this._bindEvents();
		},

		_bindClass(): void {
			this.closeNavigationContainer = this.closeNavigationContainer.bind(this);
			this.closeSubMenuContainerSiblings = this.closeSubMenuContainerSiblings.bind(this);
			this.closeMenuItemSiblings = this.closeMenuItemSiblings.bind(this);
			this.onMenuLinkClick = this.onMenuLinkClick.bind(this);
			this.onMenuLinkHover = this.onMenuLinkHover.bind(this);
			this.openNavigationContainer = this.openNavigationContainer.bind(this);
			this.resetMenuItem = this.resetMenuItem.bind(this);
			this.toggleNavigationContainer = this.toggleNavigationContainer.bind(this);
		},

		_bindEvents(): void {
			this.toggle?.addEventListener('click', this.toggleNavigationContainer);

			document.querySelectorAll('.menu__link').forEach(link => {
				const item: HTMLLIElement = link.parentElement as HTMLLIElement;
				this.resetMenuItem(item);

				link.addEventListener('click', this.onMenuLinkClick);
				link.addEventListener('mouseenter', this.onMenuLinkHover);
			});

			window.addEventListener('resize', this.closeNavigationContainer);
		},

		closeNavigationContainer(): void {
			document.documentElement.classList.remove('masthead-navigation--is-open');

			this.closeMenuItems();
		},

		closeMenuItems(): void {
			const menu: HTMLUListElement = this.menu;
			const menuItems: NodeListOf<HTMLLIElement> = menu.querySelectorAll('.menu__item') as NodeListOf<HTMLLIElement>;

			menu.classList.remove('menu--has-open-sub-menu', 'menu--has-open-sub-sub-menu');

			menuItems?.forEach(el => {
				el.classList.remove('menu__item--is-open');
				el.querySelector('.menu-container')?.classList.remove('menu-container--is-active');
			});
		},

		closeSubMenuContainerSiblings(container: HTMLElement): void {
			const siblings: NodeListOf<HTMLLIElement> = container.parentElement?.querySelectorAll('.sub-menu-container') as NodeListOf<HTMLLIElement>;

			siblings?.forEach(el => {
				if (el.dataset.menuItemId !== container.dataset.menuContainerId) {
					el.classList.remove('menu-container--is-active');
				}
			});
		},

		closeMenuItemSiblings(item: HTMLElement): void {
			const siblings: NodeListOf<HTMLLIElement> = item.parentElement?.querySelectorAll('.menu__item') as NodeListOf<HTMLLIElement>;

			siblings?.forEach(el => {
				if (el.dataset.menuItemId !== item.dataset.menuItemId) {
					el.classList.remove('menu__item--is-open');
					el.querySelector('.menu-container')?.classList.remove('menu-container--is-active');
				}
			});
		},

		onMenuLinkClick(event: Event): void {
			const link: HTMLAnchorElement = event.currentTarget as HTMLAnchorElement;
			const item: HTMLLIElement = link.parentElement as HTMLLIElement;
			const menu: HTMLUListElement = item.parentElement as HTMLUListElement;

			if (!item) {

				return;
			}

			const hasChildren: boolean = item.classList.contains('menu-item-has-children');
			const itemId: string = item.dataset.menuItemId as string;
			const menuContainer: HTMLDivElement | null = this.menu.querySelector(`.menu-container[data-menu-container-id="${itemId}"]`) as HTMLDivElement;

			const isMobile: boolean = window.innerWidth < 1280;
			const isOpen: boolean = item.classList.contains('menu__item--is-open');
			const isTabMenu: boolean = item.parentElement?.classList.contains('tab-menu') as boolean;
			const isSubMenu: boolean = item.parentElement?.classList.contains('sub-menu') as boolean;
			const isMainMenu: boolean = !isTabMenu && !isSubMenu;

			// Handle as default anchor on desktop without children
			if ( !isMobile && ( ( isMainMenu || !hasChildren ) || isOpen ) ) {

				return;
			}

			event.preventDefault();

			// Desktop
			if (!isMobile) {
				this.closeMenuItemSiblings(item);
				this.closeSubMenuContainerSiblings(menuContainer);

				item.classList.add('menu__item--is-open');

				if (hasChildren) {
					menu.classList.add('menu--has-open-sub-menu');
					menuContainer?.classList.add('menu-container--is-active');
				}
			}
			// Mobile Navigation
			else {
				const target: HTMLElement = event.target as HTMLElement;
				const isAction = target.closest('.menu__link-action');

				if (isAction) {
					const link: HTMLAnchorElement = target.parentElement as HTMLAnchorElement;
					window.location.href = link.href;
					return;
				}

				// Open Item
				if (!isOpen) {
					this.closeMenuItemSiblings(item);

					item.classList.add('menu__item--is-open');

					if (hasChildren) {
						if (isTabMenu) {
							this.menu.classList.add('menu--has-open-sub-sub-menu')
						} else {
							this.menu.classList.add('menu--has-open-sub-menu');
						}

						menu.classList.add('menu--has-open-sub-menu');
						menuContainer?.classList.add('menu-container--is-active');
					}
				}
				// Close Item
				else {
					item.classList.remove('menu__item--is-open');

					if (hasChildren) {
						if (isTabMenu) {
							this.menu.classList.remove('menu--has-open-sub-sub-menu')
						} else {
							this.menu.classList.remove('menu--has-open-sub-menu');
						}

						menu.classList.remove('menu--has-open-sub-menu');
						menuContainer?.classList.remove('menu-container--is-active');
					}
				}
			}
		},

		onMenuLinkHover(event: Event): void {
			const activeElement = document.activeElement as HTMLElement;

			if (activeElement?.classList.contains('menu__link')) {
				activeElement.blur();
			}

			const link: HTMLAnchorElement = event.currentTarget as HTMLAnchorElement;
			const item: HTMLLIElement = link.parentElement as HTMLLIElement;

			this.resetMenuItem(item);
		},

		openNavigationContainer(): void {
			document.documentElement.classList.add('masthead-navigation--is-open');
		},

		resetMenuItem(item: HTMLLIElement): void {
			const isMobile: boolean = window.innerWidth < 1280;

			if (isMobile) {

				return;
			}

			const hasChildren: boolean = item.classList.contains('menu-item-has-children');

			if (!item || !hasChildren) {

				return;
			}

			const tabMenuContainer: HTMLDivElement | null = item.querySelector(`.tab-menu-container`) as HTMLDivElement;
			const subMenuContainer: HTMLDivElement | null = item.querySelector(`.sub-menu-container`) as HTMLDivElement;

			const hasTabMenu = tabMenuContainer !== null;
			const hasSubMenu = subMenuContainer !== null;

			if (hasChildren) {
				if (hasTabMenu) {
					const activeTabMenuItem: HTMLElement = tabMenuContainer.querySelector('.current-menu-item,.current-menu-parent') as HTMLElement ?? tabMenuContainer.querySelector('.menu__item') as HTMLElement;
					const activeMenuItemID: string = activeTabMenuItem.dataset.menuItemId as string;
					const activeSubMenuContainer: HTMLElement = item.querySelector( `.sub-menu-container[data-menu-container-id="${activeMenuItemID}"]` ) ?? subMenuContainer;

					console.log(activeTabMenuItem, activeSubMenuContainer, activeMenuItemID);

					this.closeMenuItemSiblings(activeTabMenuItem);
					activeTabMenuItem.classList.add('menu__item--is-open');

					this.closeSubMenuContainerSiblings(activeSubMenuContainer);
					activeSubMenuContainer.classList.add( 'menu-container--is-active' );
				}

				else if (hasSubMenu) {
					this.closeSubMenuContainerSiblings(subMenuContainer);
					subMenuContainer.classList.add('menu-container--is-active');
				}
			}
		},

		toggleNavigationContainer(event: PointerEvent): void {
			event.preventDefault();

			document.documentElement.classList.contains('masthead-navigation--is-open')
				? this.closeNavigationContainer()
				: this.openNavigationContainer();
		},
	};

	MastheadObject._init();
	return MastheadObject;
}

